import React, { useEffect } from "react";
import { Form, TextInput, Button, useClasses, Row, Col, Typo, useI18n, } from "../../";
import Seperator from "../Seperator";
import { login } from "../../hooks/useAuthenticator";
import StateHandler from "../StateHandler";
const styes = (theme) => ({
    alignRight: {
        textAlign: "right",
    },
});
export default function Login(props) {
    const classes = useClasses(styes);
    const { state, values, errors, autoLogin } = props.state;
    const setState = props.setState;
    const onChangeString = (field) => {
        return (value) => setState({
            ...props.state,
            values: { ...values, [field]: value || "" },
        });
    };
    const onLogin = async (event) => {
        if (event)
            event.preventDefault();
        const session = await login(props.state, setState);
        if (session)
            setTimeout(() => {
                const { challenges } = session;
                if (challenges && challenges.length)
                    if (challenges.includes("verify_email"))
                        props.onModeChange("challengeEmail");
                    else if (challenges.includes("verify_password"))
                        props.onModeChange("challengePassword");
                    else {
                        setState({ ...props.state, state: "error" });
                        console.error("Unknown challenges in " + JSON.stringify(challenges));
                    }
                else
                    props.setSession(session);
            }, 1000);
    };
    useEffect(() => {
        if (autoLogin && state === "ok" && values.email && values.password)
            onLogin();
    });
    const i18n = useI18n(props.translationGroup);
    const i18nErrors = useI18n("errors");
    return (React.createElement("div", null,
        React.createElement(Typo, { variant: "h2", margin: "none" }, i18n.get("signIn")),
        React.createElement(StateHandler, { state: state, onErrorReset: () => {
                setState({ ...props.state, state: "ok" });
            } },
            React.createElement(Form, { spacing: 8, vertical: true, horizontalAlign: "right", root: { left: 0, right: 0, top: 16, bottom: 16 }, onSubmit: (e) => e.preventDefault() },
                React.createElement(TextInput, { inline: true, autoComplete: "on", label: i18n.get("username"), value: values.email, onChange: onChangeString("email"), error: errors.email !== "notValid"
                        ? errors.email && i18nErrors.get(errors.email)
                        : "" }),
                React.createElement(TextInput, { inline: true, autoComplete: "on", label: i18n.get("password"), password: true, value: values.password, onChange: onChangeString("password"), error: errors.password && i18nErrors.get(errors.password) }),
                React.createElement(Button, { xs: "120px", primary: true, onClick: onLogin }, i18n.get("signIn"))),
            React.createElement(Seperator, null),
            React.createElement(Row, { root: { top: 16 } },
                React.createElement(Col, { xs: 5 },
                    React.createElement(Button, { link: true, onClick: () => props.onModeChange("resetPassword") }, i18n.get("forgot_password?"))),
                React.createElement(Col, { xs: 5 },
                    React.createElement("div", { className: classes.alignRight },
                        React.createElement(Button, { link: true, onClick: () => props.onModeChange("register") }, i18n.get("signUp?"))))))));
}
